
import { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";

// Soft UI Dashboard React examples
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Soft UI Dashboard React icons
import Cube from "examples/Icons/Cube";
import Document from "examples/Icons/Document";
import Settings from "examples/Icons/Settings";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faCalendarMinus, faChartLine, faExternalLinkSquareAlt, faFolderOpen, faGraduationCap, faHouse, faIdCard, faNoteSticky, faPersonWalkingLuggage, faUserClock, faUserTag } from '@fortawesome/free-solid-svg-icons'

// Soft UI Dashboard React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import burceMars from "assets/images/bruce-mars.jpg";
import burceMars2 from "assets/images/trt-arabi-app-blue2.png";
//import curved0 from "assets/images/curved-images/Trt-press-release-2.png";
import curved0 from "assets/images/curved-images/trt-press1.jpeg";
import { createTheme, ThemeProvider } from '@mui/material/styles';

/* eslint-disable react/prop-types */

function Header(props) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  const { id } = useParams();

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (newValue) => {
    setTabValue(newValue);
    console.log(newValue);
    props.onChange(newValue);
  };

  const theme = createTheme({
    typography: {
        //fontSize: '12px !important',
        color: "#aaa",

        fontFamily: [
            "Roboto", "Helvetica", "Arial",
            'sans-serif'
            // Diğer fontlar...
        ].join(','),
    },
    // Diğer tema özelleştirmeleri...
});

  return (
    <SoftBox position="relative">
      <style>
        {`
    @media print {
      body, html {
        -webkit-print-color-adjust: exact; /* Chrome, Safari */
        color-adjust: exact;  /* Firefox */
      }
      .print-card {
        background-color: #f0f0f0 !important; // İstediğiniz arka plan rengi
      }
      .print-chart-container {
        width: 100%;
        height: 120px;
        
        padding-bottom: 14px;
      }
      .print-chart-container canvas {
        width: 100% !important;
        height: 120px !important;
        
        padding-bottom: 14px;
      }
    }
  `}
      </style>
      <SoftBox
        display="flex"
        alignItems="center"
        position="relative"
        //minHeight="18.75rem"
        height="18rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${curved0})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
          "@media print": {
            height: '200px', // Yazdırma sırasında backdrop-filter efektini kaldır
            

          }
        }}
      />
      <Card 
        sx={{
          backdropFilter: `saturate(200%) blur(30px)`,
          backgroundColor: ({ functions: { rgba }, palette: { white } }) => rgba(white.main, 0.7),
          boxShadow: ({ boxShadows: { navbarBoxShadow } }) => navbarBoxShadow,
          position: "relative",
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
          "@media print": {
            backdropFilter: 'none', // Yazdırma sırasında backdrop-filter efektini kaldır
            backgroundColor: 'white !important', // Yazdırma için daha net bir arka plan rengi kullan

          }
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <SoftAvatar
              src={burceMars2}
              alt="profile-image"
              variant="rounded"
              size="xxl"
              shadow="sm"

            />
          </Grid>

          <Grid item>
            <SoftBox height="100%" mt={0.5} lineHeight={1}>

              <SoftTypography variant="h5" fontWeight="medium">
                TRT Arabi Kanal Yıllık Raporu
              </SoftTypography>
              <SoftTypography variant="button" color="text" fontWeight="medium">
                {props.id} Yılı Yayın Özeti
              </SoftTypography>
            </SoftBox>
          </Grid>
          <Grid item xs={12} md={12} lg={12} sx={{ ml: "auto" }}>
            <AppBar position="static">
              {/* <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={(event, newValue) => handleSetTabValue(newValue)}
                sx={{ background: "transparent" }}
              >
                <Tab value={0} label="Genel" icon={<Cube />} />
                <Tab value={1} label="Kurum" icon={<FontAwesomeIcon icon={faBuilding} />} />
                <Tab value={2} label="Yayın" icon={<FontAwesomeIcon icon={faGraduationCap} />} />

              </Tabs> */}
            </AppBar>
          </Grid>
        </Grid>
      </Card>
    </SoftBox>
  );
}

export default Header;
